import * as React from 'react';

function SvgExpiredIcon(props) {
  return (
    <svg width={16} height={16} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 0a8 8 0 110 16A8 8 0 018 0zm.045 4.005a.845.845 0 00-.845.845v3.31c0 .328.187.612.46.752l2.822 1.629a.85.85 0 00.85-1.474L8.89 7.657V4.85a.845.845 0 00-.845-.845z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgExpiredIcon;
